import React from 'react';
import Svg, { Path } from 'react-native-svg';

export const IconOriginal = () => {
  return (
    <Svg width="24" height="23" viewBox="0 0 24 23" fill="none">
      <Path
        d="M22.3569 0.5L13.1687 7.375L14.8773 3.32333L22.3569 0.5Z"
        fill="#E17726"
        stroke="#E17726"
        strokeWidth="0.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M1.16333 0.5L10.2697 7.43917L8.64292 3.32333L1.16333 0.5Z"
        fill="#E27625"
        stroke="#E27625"
        strokeWidth="0.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M19.049 16.4408L16.6042 20.2175L21.8391 21.675L23.3386 16.5233L19.049 16.4408Z"
        fill="#E27625"
        stroke="#E27625"
        strokeWidth="0.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M0.190918 16.5233L1.68138 21.675L6.9071 20.2175L4.47146 16.4408L0.190918 16.5233Z"
        fill="#E27625"
        stroke="#E27625"
        strokeWidth="0.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M6.6255 10.0607L5.17139 12.2791L10.3517 12.5174L10.179 6.87988L6.6255 10.0607Z"
        fill="#E27625"
        stroke="#E27625"
        strokeWidth="0.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M16.8951 10.0608L13.2871 6.81583L13.1689 12.5175L18.3492 12.2792L16.8951 10.0608Z"
        fill="#E27625"
        stroke="#E27625"
        strokeWidth="0.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M6.90723 20.2175L10.0427 18.6867L7.34346 16.56L6.90723 20.2175Z"
        fill="#E27625"
        stroke="#E27625"
        strokeWidth="0.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M13.4778 18.6867L16.6041 20.2175L16.177 16.56L13.4778 18.6867Z"
        fill="#E27625"
        stroke="#E27625"
        strokeWidth="0.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M16.6041 20.2175L13.4778 18.6867L13.7323 20.74L13.705 21.6109L16.6041 20.2175Z"
        fill="#D5BFB2"
        stroke="#D5BFB2"
        strokeWidth="0.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M6.90698 20.2175L9.81521 21.6109L9.79703 20.74L10.0424 18.6867L6.90698 20.2175Z"
        fill="#D5BFB2"
        stroke="#D5BFB2"
        strokeWidth="0.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M9.86973 15.2033L7.27051 14.4333L9.10632 13.5808L9.86973 15.2033Z"
        fill="#233447"
        stroke="#233447"
        strokeWidth="0.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M13.6504 15.2033L14.4138 13.5808L16.2587 14.4333L13.6504 15.2033Z"
        fill="#233447"
        stroke="#233447"
        strokeWidth="0.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M6.90707 20.2176L7.36149 16.4409L4.47144 16.5234L6.90707 20.2176Z"
        fill="#CC6228"
        stroke="#CC6228"
        strokeWidth="0.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M16.1589 16.4409L16.6043 20.2176L19.049 16.5234L16.1589 16.4409Z"
        fill="#CC6228"
        stroke="#CC6228"
        strokeWidth="0.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M18.349 12.2793L13.1687 12.5176L13.6504 15.2035L14.4138 13.581L16.2587 14.4335L18.349 12.2793Z"
        fill="#CC6228"
        stroke="#CC6228"
        strokeWidth="0.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M7.27052 14.4335L9.10634 13.581L9.86975 15.2035L10.3514 12.5176L5.17114 12.2793L7.27052 14.4335Z"
        fill="#CC6228"
        stroke="#CC6228"
        strokeWidth="0.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M5.17114 12.2793L7.34322 16.5601L7.27052 14.4335L5.17114 12.2793Z"
        fill="#E27525"
        stroke="#E27525"
        strokeWidth="0.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M16.2588 14.4335L16.177 16.5601L18.3491 12.2793L16.2588 14.4335Z"
        fill="#E27525"
        stroke="#E27525"
        strokeWidth="0.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M10.3513 12.5176L9.86963 15.2035L10.4785 18.3751L10.6149 14.1951L10.3513 12.5176Z"
        fill="#E27525"
        stroke="#E27525"
        strokeWidth="0.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M13.1688 12.5176L12.9143 14.186L13.0415 18.3751L13.6505 15.2035L13.1688 12.5176Z"
        fill="#E27525"
        stroke="#E27525"
        strokeWidth="0.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M13.6504 15.2033L13.0415 18.375L13.4777 18.6867L16.1769 16.56L16.2587 14.4333L13.6504 15.2033Z"
        fill="#F5841F"
        stroke="#F5841F"
        strokeWidth="0.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M7.27051 14.4333L7.34321 16.56L10.0424 18.6867L10.4786 18.375L9.86973 15.2033L7.27051 14.4333Z"
        fill="#F5841F"
        stroke="#F5841F"
        strokeWidth="0.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M13.705 21.6108L13.7322 20.74L13.4959 20.5383H10.0242L9.79703 20.74L9.81521 21.6108L6.90698 20.2175L7.92486 21.0608L9.98788 22.5H13.5232L15.5953 21.0608L16.6041 20.2175L13.705 21.6108Z"
        fill="#C0AC9D"
        stroke="#C0AC9D"
        strokeWidth="0.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M13.4778 18.6867L13.0416 18.375H10.4787L10.0425 18.6867L9.79712 20.74L10.0243 20.5383H13.496L13.7323 20.74L13.4778 18.6867Z"
        fill="#161616"
        stroke="#161616"
        strokeWidth="0.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M22.7478 7.82417L23.5203 4.02917L22.357 0.5L13.4778 7.14584L16.8949 10.0608L21.7208 11.4817L22.7841 10.2258L22.3206 9.88667L23.0568 9.20834L22.4933 8.76834L23.2294 8.2L22.7478 7.82417Z"
        fill="#763E1A"
        stroke="#763E1A"
        strokeWidth="0.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M0 4.02917L0.781586 7.82417L0.281734 8.2L1.02697 8.76834L0.463499 9.20834L1.19964 9.88667L0.736145 10.2258L1.79947 11.4817L6.6253 10.0608L10.0425 7.14584L1.16329 0.5L0 4.02917Z"
        fill="#763E1A"
        stroke="#763E1A"
        strokeWidth="0.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M21.7208 11.4817L16.895 10.0608L18.3491 12.2792L16.177 16.56L19.0489 16.5233H23.3385L21.7208 11.4817Z"
        fill="#F5841F"
        stroke="#F5841F"
        strokeWidth="0.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M6.62537 10.0608L1.79953 11.4817L0.190918 16.5233H4.47146L7.34334 16.56L5.17126 12.2792L6.62537 10.0608Z"
        fill="#F5841F"
        stroke="#F5841F"
        strokeWidth="0.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M13.1688 12.5174L13.4778 7.14574L14.8773 3.32324H8.64282L10.0424 7.14574L10.3514 12.5174L10.4696 14.2041L10.4786 18.3749H13.0415L13.0506 14.2041L13.1688 12.5174Z"
        fill="#F5841F"
        stroke="#F5841F"
        strokeWidth="0.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
};
